import { usePublishedBoxStore, publishQueries } from '@/entities/sets/publish';
import { usePersistStore } from '@/shared/lib/store';
import { Icon } from '@/shared/ui';
import { ByPublishStntDetailListFilter } from '@/widgets/filter';
import { findUserName } from '@/widgets/report/phase2/report-contents/answer-section/model/table.mapper';
import { SearchBarType2 } from '@/widgets/search-bar';
import { ByClassStudentDetailTable } from '@/widgets/table-list';
import { useQueryClient } from '@tanstack/react-query';
import { useSearch } from '@tanstack/react-router';
import moment from 'moment';
import { FC, useState, useMemo, useEffect } from 'react';

interface DetailPublishBoxProps {
    stntData?: {
        claName: string;
        userId: string;
        name: string;
    };
    onBackProps: () => void;
}
export const DetailPublishBox: FC<DetailPublishBoxProps> = (props) => {
    const queryClient = useQueryClient();
    const search = useSearch({ strict: false });
    const { stdtUserIds } = search;

    const { sUserId } = usePersistStore();
    const { searchKeyword, searchPage } = usePublishedBoxStore();
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();
    const [dateTab, setDateTab] = useState<string>();

    const startFrom = startDate ? moment(startDate).format('YYYY-MM-DD') : undefined;
    const endTo = endDate ? moment(endDate).format('YYYY-MM-DD') : undefined;

    const queryParams = useMemo(
        () => ({
            wrterId: sUserId,
            stdtUserIds: stdtUserIds ? stdtUserIds : (props.stntData?.userId ?? ''),
            keyword: searchKeyword,
            dateFrom: startFrom,
            dateTo: endTo,
            page: searchPage,
            size: 10,
        }),
        [sUserId, searchKeyword, endDate, startDate, searchPage]
    );

    const { data, refetch } = publishQueries.detail.getPubStntDetailList(
        queryParams,
        !!startFrom && !!endTo
    );

    useEffect(() => {
        return () => {
            queryClient.removeQueries({
                queryKey: ['publish-list', 'stntListDetail'],
            });
        };
    }, []);

    const onRefetch = () => refetch();

    const backHandler = () => {
        props.onBackProps();
    };

    return (
        <>
            <div className="page-header-box box-style1 // con-mt3">
                <button type="button" className="btn btn-default line small" onClick={backHandler}>
                    <Icon icon="back2" txt="뒤로가기" />
                    학생 목록
                </button>
                <p className="peronal-info">
                    <span className="peronal-info--item">
                        이름 :{' '}
                        {findUserName(stdtUserIds ? stdtUserIds : (props.stntData?.userId ?? ''))}
                    </span>
                    {/* <span className="peronal-info--item">클래스 : 비상초 5학년 1반 외 2개</span> */}
                </p>
            </div>
            <SearchBarType2
                title="목록 검색"
                placeholder={'자료 이름 및 키워드를 입력하세요.'}
                inputTitle="내 발행함 자료명 검색"
            />
            <ByPublishStntDetailListFilter
                startDate={startDate}
                endDate={endDate}
                dateTab={dateTab}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setDateTab={setDateTab}
            />
            {/* <PubBoxSelectedStnt stntData={props.stntData} /> */}
            <ByClassStudentDetailTable
                data={data}
                userId={stdtUserIds ? stdtUserIds : (props.stntData?.userId ?? '')}
            />
        </>
    );
};
